import React from 'react';
import { Phone } from 'lucide-react';
import { contactInfo } from '../data/restaurantData';

const HeroSection = ({ scrollToSection }) => {
  return (
    <section id="home" className="min-h-screen flex items-center relative overflow-hidden">
      {/* Animated Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transform scale-105 transition-transform duration-[20s] ease-out hover:scale-110"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)), url('/images/restaurant_interior_elegant.jpg')`
        }}
      />
      
      {/* Enhanced overlay pattern for better text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60"></div>
      
      <div className="max-w-7xl mx-auto px-8 text-center relative z-10">
        {/* Animated title entrance with improved contrast */}
        <div className="mb-12 animate-fade-in-up" style={{animationDelay: '0.5s'}}>
          <div className="relative">
            {/* Text shadow for better readability */}
            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-thin tracking-[0.1em] md:tracking-[0.2em] mb-6 leading-tight text-white drop-shadow-2xl" 
                style={{textShadow: '2px 2px 8px rgba(0, 0, 0, 0.8), 0 0 20px rgba(0, 0, 0, 0.6)'}}>
              <span className="bg-gradient-to-r from-red-500 via-red-400 to-red-600 bg-clip-text text-transparent">
                NOU VALENTINO
              </span>
            </h1>
          </div>
          <div className="w-32 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent mx-auto mb-8"></div>
        </div>
        
        <div className="animate-fade-in-up" style={{animationDelay: '1s'}}>
          <div className="relative bg-black/40 backdrop-blur-sm rounded-lg p-4 md:p-6 mx-auto max-w-4xl">
            <p className="text-lg md:text-xl lg:text-2xl text-white mb-8 md:mb-12 font-light leading-relaxed tracking-wide">
              Una sofisticata experiencia culinaria de cocina Belga-Francesa 
              con platos sofisticados, elaboración casera y tradicional en el corazón de Altea la Vella
            </p>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row gap-4 md:gap-8 justify-center items-center animate-fade-in-up" style={{animationDelay: '1.5s'}}>
          <button 
            onClick={() => scrollToSection('menu')}
            className="group relative bg-transparent border border-red-600 text-white px-8 md:px-12 py-3 md:py-4 text-sm md:text-base tracking-widest font-light hover:bg-red-600 transition-all duration-500 overflow-hidden"
          >
            <span className="relative z-10">DESCUBRIR MENÚ</span>
            <div className="absolute inset-0 bg-red-600 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
          </button>
          
          <div className="flex items-center gap-3 text-white/80 group cursor-pointer">
            <div className="p-2 border border-white/30 rounded-full group-hover:border-red-600 transition-colors duration-300">
              <Phone size={16} className="md:w-[18px] md:h-[18px]" />
            </div>
            <div className="text-sm md:text-base font-light tracking-wider">
              <div className="text-white/60 text-xs md:text-sm mb-1">RESERVAS</div>
              <div className="group-hover:text-red-600 transition-colors duration-300">{contactInfo.phone}</div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent"></div>
      </div>
    </section>
  );
};

export default HeroSection;